import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APP_TITLE } from 'configs/AppConfig';
import service from 'auth/FetchInterceptor';
import { setUnreadNotifications } from 'store/slices/authSlice';

const MAX_COUNT = 99;
const POLL_INTERVAL = 60000;

const formatCount = (unread) => (unread > MAX_COUNT ? `${MAX_COUNT}+` : unread);

export default function useNotificationTitle() {
	const dispatch = useDispatch();
	const token = useSelector((state) => state.auth.token);
	const unread = useSelector(
		(state) => Number(state.auth.currentUser?.unreadNotifications) || 0
	);

	const refresh = useCallback(async () => {
		if (!token) return;

		try {
			const response = await service({
				method: 'GET',
				url: 'notification/unread-count'
			});
			dispatch(setUnreadNotifications(Number(response?.count) || 0));
		} catch (error) {
			console.debug('Compteur de notifications non rafraîchi', error);
		}
	}, [dispatch, token]);

	useEffect(() => {
		if (!token) return undefined;

		refresh();

		const interval = setInterval(refresh, POLL_INTERVAL);
		window.addEventListener('focus', refresh);

		return () => {
			clearInterval(interval);
			window.removeEventListener('focus', refresh);
		};
	}, [token, refresh]);

	useEffect(() => {
		document.title = unread > 0
			? `(${formatCount(unread)}) ${APP_TITLE}`
			: APP_TITLE;
	}, [unread]);
}
